import React from 'react';
import { motion } from 'framer-motion';
import type { Campaign } from '../../redux/slices/campaignsSlice';

interface CampaignCardProps {
  campaign?: Campaign;
  index: number;
  isNewlyAdded: boolean;
  onCardClick: (campaignId: string) => void;
}

export const CampaignCard: React.FC<CampaignCardProps> = ({
  campaign,
  index,
  isNewlyAdded,
  onCardClick,
}) => {
  return (
    <motion.div
      key={index}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ 
        opacity: campaign ? 1 : 0.3, 
        scale: 1,
      }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      className={`relative`}
    >
      {campaign ? (
        <div
          onClick={() => onCardClick(campaign.id)}
          className="cursor-pointer group relative rounded-lg overflow-hidden aspect-[3/4] bg-gray-900 hover:ring-2 hover:ring-brand-primary transition-all"
        >
          {campaign.flyerUrl || campaign.flyer?.image?.storage_url ? (
            <>
              <img
                src={campaign.flyerUrl || campaign.flyer?.image?.storage_url}
                alt={campaign.campaignName || campaign.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              {/* Overlay on hover */}
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300" />
            </>
          ) : (
            // Campaign exists but flyer not ready yet
            <div className="w-full h-full flex flex-col items-center justify-center bg-gradient-to-br from-gray-700 to-gray-800 p-4 animate-pulse-slow">
              <div className="w-16 h-16 bg-gray-600 rounded-lg mb-3 opacity-50" />
              <p className="text-gray-400 text-xs text-center font-medium">
                {campaign.campaignName || campaign.title}
              </p>
              <p className="text-gray-500 text-[10px] text-center mt-1">
                Generating flyer...
              </p>
            </div>
          )}
        </div>
      ) : (
        <div className="rounded-lg overflow-hidden aspect-[3/4] bg-gradient-to-br from-gray-700 to-gray-800 flex items-center justify-center animate-pulse-slow">
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-700 rounded-lg mx-auto mb-2 opacity-40" />
            <div className="h-2 w-24 bg-gray-700 rounded mx-auto opacity-30" />
          </div>
        </div>
      )}
    </motion.div>
  );
};
